export default __webpack_public_path__ + "static/media/collapseArrow.bd3ac8b6.svg";